
<template>
  <div class="quoteBox">
    <p class="quotePara">"{{para}}"</p>
    <h1 class="quotePerson">{{author}}</h1>
    <h2 class="quoteTitle">{{title}}</h2>
  </div>
</template>

<script>
export default {
  name: "Quote",
  props: ["para", "author", "title"]
};
</script>

<style lang="scss">
@import "./Quote.scss";
</style>